/* eslint-disable react/no-array-index-key,react/no-danger */
import * as React from "react"
import * as R from "ramda"

import { useIntlNitro } from "../services/context"

// @ts-expect-error: Flow to TS migration.
type Record<T, V> = Partial<Record<T, V>>

type Props = {
  t: string
  defaultMessage?: string
  // @ts-expect-error: Flow to TS migration.
  values?: Record<string, React.ReactNode>
  // @ts-expect-error: Flow to TS migration.
  tags?: Record<string, (text: React.ReactNode) => React.ReactElement>
  transform?: (value: string) => string
}

// @ts-expect-error: Flow to TS migration.
function substituteValue(text: string, valueSet: Record<string, React.ReactNode>) {
  return text
    .split("__")
    .filter(Boolean)
    .map((word, i) => {
      if (word in valueSet) {
        return <React.Fragment key={i}>{valueSet[word]}</React.Fragment>
      }

      return <span key={i} dangerouslySetInnerHTML={{ __html: word }} />
    })
}

/**
 * @deprecated use `react-intl`'s `FormattedMessage` instead
 */
const TranslateNode = ({
  t,
  defaultMessage,
  values = {},
  tags = {},
  transform = R.identity,
}: Props) => {
  const intl = useIntlNitro()

  const text = React.useMemo(() => transform(intl.translate(t, {}, { defaultMessage })), [
    intl,
    t,
    defaultMessage,
    transform,
  ])

  const tagsFilled = React.useMemo(
    () =>
      // Fix this the next time the file is edited. (Flow to TS)
      // @ts-expect-error: Flow to TS migration.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Object.keys(tags).reduce<Record<string, any>>((acc, key) => {
        const res = new RegExp(`<${key}>([^<>]*)<\\/${key}>`).exec(text)
        const core = res?.[1]
        if (!core) {
          return acc
        }

        const fn = tags[key]
        return { ...acc, [key]: fn(substituteValue(core, values)) }
      }, {}),
    [tags, text, values],
  )

  const textFilled = React.useMemo(
    () =>
      Object.keys(tags).reduce(
        (acc, key) => acc.replace(new RegExp(`<${key}>([^<>]*)<\\/${key}>`), `__${key}__`),
        text,
      ),
    [tags, text],
  )

  return <>{substituteValue(textFilled, { ...values, ...tagsFilled })}</>
}

export default TranslateNode
